import React, { Component } from 'react'
import { Container, Row, Col, Tabs, Tab, Table } from 'react-bootstrap'
import HeaderTop from './HeaderTop'
import SideNavTop from './SideNavTop'
import Footer from './Footer'

import '../Accueil.css'


class Natation extends Component {
    state = {
        redirect: false,
        search: '',
        key: 'maitre'
    }

    handleCHange = event => {
        const { name, value } = event.target
        this.setState({ [name]: value })
    }

    handleSubmit = event => {
        //on gere le form
        event.preventDefault()
        this.props.history.push(`/recherche/${this.state.search}`);

    }
    
    setRedirect = () => {
        this.setState({
          redirect: true
        })
      }

    handleSubmitFacebbok = () => {
        if (this.state.redirect) {
            window.location.href = "https://www.facebook.com/clubCAPN/";
        }
    }

    handleSelect(key) {
        if (key === "maitre")
            this.props.history.push(`/competiton/maitres-nageurs`);
        else if (key === "natation")
            this.props.history.push(`/competiton/natation`);
        else if (key === "sauvetage")
            this.props.history.push(`/competiton/sauvetage-sportif`);
        else if (key === "resultat")
            this.props.history.push(`/competiton/resultats`);
        else if (key === "synchro")
            this.props.history.push(`/competiton/nage-synchronisee`);
    }

    render() {
        console.log(this.state.key)
        return (
            <>
                <Container fluid>
                <Row>
            <SideNavTop/>
            <Col lg={10} md={12} sm={12} xs={12} id="page-content-wrapper" className="nopadding">
              <HeaderTop
                handleSubmit={this.handleSubmit}
                handleCHange={this.handleCHange}
                handleSubmitFacebbok={this.handleSubmitFacebbok}
                setRedirect={this.setRedirect}
              />

                            <Col lg={12} md={12} sm={12} xs={12} className="nopadding">

                                <Tabs
                                    id="controlled-tab"
                                    activeKey={this.state.key}
                                    onSelect={key => this.handleSelect(key)}
                                >                       <Tab eventKey="maitre" title="Maître Nageurs">
                                    </Tab>
                                    <Tab eventKey="synchro" title="Nage synchronisée">
                                    </Tab>
                                    <Tab eventKey="natation" title="Natation" >
                                    </Tab>
                                    <Tab eventKey="sauvetage" title="Sauvetage sportif">
                                    </Tab>
                                    <Tab eventKey="resultat" title="Résultats des compétitions" >
                                    </Tab>
                                </Tabs>
                            </Col>


                            <Col lg={12} md={12} sm={12} xs={12} className="nopadding">
                                <Row>
                                    <Col lg={12} md={12} sm={12} xs={12} className="nopadding">
                                        <div className="histoire-content">
                                            <h1><span>Natation - Saison 2020-2021</span></h1>
                                            <h2>INFORMATIONS</h2>
                                            <p className="pCenter">Le club de natation permet aux nageurs âgés entre 7 et 18 ans d'évoluer à différents niveaux. 
                                                Le club comprends plusieurs groupes d'entraînements.<br />

                                            Il permet aqux participants de travailler des objectifs techniques et des temps spécifiques,
                                             en vue de faire des compétitions. Les entraînements sont obligatoire.<br />

                                            Pour tous les nouveaux nageurs une évaluation est obligatoire, elle se tiendra le mardi 8 septembre 2020 de 17h00 à 18h00.<br />
                                            Pour toute information supplémentaire veuillez écrire à notre entraîneure-chef au <strong>infonatationcapn@gmail.com</strong><br /><br />

                                            <i>Inscriptions sur Amilia:</i> 2 septembre 2020<br />
                                            <i>Début des entraînements:</i> 8 septembre 2020 <br />

                                            Prendre note qu'il y aura arrêt des entraînements Pour la période des fêtes du 19 décembre 2020
                                             au 3 janvier 2021 inclusivement ainsi que la semaine de relâche.<br /><br />
                                            </p>
                                            <h3>SUJET À CHANGEMENT</h3>
                                            <h2>GROUPES DE COMPÉTITION</h2>

                                            <p className="pCenter"> <strong>GROUPE LES RECRUES </strong> - 6 heures d'entraînement par semaine<br />
                                            <strong>Pré-requis:</strong> <br />
                                                - Agés entre 7 et 10 ans<br />
                                                - Niveau junior 4 complété<br />
                                                - Nager 25m en style libre<br />
                                                - Nager 25m au dos crawlé.<br />
                                                - Seuls les nageurs déjà pésents durant la saison 2019-2020 peuvent s'inscrire.<br />
                                                - Pour tous les nouveaux nageurs une évaluation est obligatoire.<br />
                                                - 2 entraînements par semaine est obligatoire. <br />
                                                - Compétition désignées par l'entraineur obligatoire.<br /><br />
                                                <strong>Coût:</strong> 420 $ pour les entraînements de natation<br />
                                                        250 $ pour compétitions au cours de l'année<br /><br />
                                            
                                                        <strong>Frais d'affiliations:</strong> 8 ans et moins (au 30 Novembre 2020) : 67 $<br />
                                                                            9 -10 ans( au 30 Novembre 2020) : 87 $<br /><br />
                                                                            
                                                        
                                                                            <strong>Durée:</strong> Du 8 septembre 2020 au 19 juin 2021<br /><br />
                                            </p>

                                            <p className="pCenter"> <strong>GROUPE LES JUNIOR </strong>- 10 heures d'entraînement par semaine<br />
                                            <strong>Pré-requis:</strong> <br />
                                            - 13 ans et plus<br />
                                            - Seuls les nageurs déjà présents durant la saison 2019-2020 peuvent s'inscrire.<br />
                                            - Pour tous les nouveaux nageurs, une évaluation est obligatoire.<br />
                                            - 4 entrainements minimum par semaine obligatoire.<br />
                                            - Compétitions désignées par l'entraineur obligatoire.<br /><br />
                                                <strong>Coût:</strong> 620 $ pour les entrainements de natation<br />
                                                700 $  compétitions au cours de l'année<br /><br />
                                            
                                                        <strong>Frais d'affiliations:</strong> 11-14 ans (au 30 Novembre 2020) : 114 $<br />
                                            15 ans et plus (au 30 Novembre 2020) : 134 $<br /><br />
                                                                            
                                                        
                                                                            <strong>Durée:</strong> Du 8 septembre 2020 au 19 juin 2021<br /><br />
                                            </p>
                                          
                                            <p className="pCenter"> <strong>GROUPE RELÈVE </strong>- 8 heures d'entraînement par semaine<br />
                                            <strong>Pré-requis:</strong> <br />
                                            - Agés entre 11 ans et 12 ans<br />
                                            - Seuls les naguers déjà présents durant la saison 2019-2020 peuvent s'inscrire.<br />
                                            - Pour tous les nouveaux nageurs, une évaluation est obligatoire.<br />
                                            - 3 entraînements minimum par semaine obligatoire<br />
                                            - Compétitions désignés par l'entraineur<br /><br />
                                                <strong>Coût:</strong> 480 $ pour les entrainements de natation<br />
                                                480 $  compétitions au cours de l'année<br /><br />
                                            
                                                        <strong>Frais d'affiliations:</strong> 11-14 ans ( au 30 Novembre 2020) : 114 $<br /><br />
                                                                            
                                                                            <strong>Durée:</strong> Du 8 septembre 2020 au 19 juin 2021<br /><br />
                                            </p>

                                            <p className="pCenter"> <strong>GROUPE RECRÉATIF</strong>- 3 heures d'entraînement par semaine<br />
                                            <strong>Pré-requis:</strong> <br />
                                            - Pour les nageurs de 18 ans et moins qui souhaitent continuer à pratiquer la natation sans participer aux compétitions<br /><br />

                                                <strong>Coût:</strong> 330 $ pour les entrainements de natation<br /><br />
                                            
                                                        <strong>Frais d'affiliations:</strong> Affiliations non-compétitif : 60$<br /><br />
                                                                            
                                                                            <strong>Durée:</strong> Du 14 septembre 2020 au 12 juin 2021<br /><br />
                                            </p>


                                            <Table striped bordered hover>
                                            <thead>
                                                <tr>
                                                    <th colspan="7">Horaire - Recrues</th>
                                                </tr>
                                                <tr>
                                                <th>Lundi</th>
                                                <th>Mardi</th>
                                                <th className="table-resp">Mercredi</th>
                                                <th>Jeudi</th>
                                                <th className="table-resp">Vendredi</th>
                                                <th>Samedi</th>
                                                <th className="table-resp">Dimanche</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                <td>17h00 à 19h00</td>
                                                <td className="table-resp"></td>
                                                <td>17h00 à 19h00</td>
                                                <td className="table-resp"></td>
                                                <td></td>
                                                <td>8h30 à 10h30</td>
                                                <td className="table-resp"></td>
                                                </tr>
                                            </tbody>
                                            </Table>

                                            
                                            <Table striped bordered hover>
                                            <thead>
                                                <tr>
                                                    <th colspan="7">Horaire - Junior</th>
                                                </tr>
                                                <tr>
                                                <th>Lundi</th>
                                                <th>Mardi</th>
                                                <th className="table-resp">Mercredi</th>
                                                <th>Jeudi</th>
                                                <th className="table-resp">Vendredi</th>
                                                <th>Samedi</th>
                                                <th className="table-resp">Dimanche</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                <td></td>
                                                <td>6h15 à 7h45</td>
                                                <td className="table-resp"></td>
                                                <td>6h15 à 7h45</td>
                                                <td className="table-resp"></td>
                                                <td>7h00 à 10h00</td>
                                                <td className="table-resp"></td>
                                                </tr>

                                                <tr>
                                                <td>16h45 à18h45</td>
                                                <td></td>
                                                <td className="table-resp"></td>
                                                <td>16h45 à 18h45</td>
                                                <td className="table-resp"></td>
                                                <td></td>
                                                <td className="table-resp"></td>
                                                </tr>
                                            </tbody>
                                            </Table>

                                            <Table striped bordered hover>
                                            <thead>
                                                <tr>
                                                    <th colspan="7">Horaire -Relève</th>
                                                </tr>
                                                <tr>
                                                <th>Lundi</th>
                                                <th>Mardi</th>
                                                <th className="table-resp">Mercredi</th>
                                                <th>Jeudi</th>
                                                <th className="table-resp">Vendredi</th>
                                                <th>Samedi</th>
                                                <th className="table-resp">Dimanche</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                <td></td>
                                                <td></td>
                                                <td className="table-resp"></td>
                                                <td></td>
                                                <td className="table-resp"></td>
                                                <td>7h00 à 9h00</td>
                                                <td className="table-resp"></td>
                                                </tr>

                                                <tr>
                                                <td>16h45 à18h45</td>
                                                <td>16h45 à 18h45</td>
                                                <td className="table-resp"></td>
                                                <td>16h45 à 18h45</td>
                                                <td className="table-resp"></td>
                                                <td></td>
                                                <td className="table-resp"></td>
                                                </tr>
                                            </tbody>
                                            </Table>

                                            <Table striped bordered hover>
                                            <thead>
                                                <tr>
                                                    <th colspan="7">Horaire - Junior</th>
                                                </tr>
                                                <tr>
                                                <th>Lundi</th>
                                                <th>Mardi</th>
                                                <th className="table-resp">Mercredi</th>
                                                <th>Jeudi</th>
                                                <th className="table-resp">Vendredi</th>
                                                <th>Samedi</th>
                                                <th className="table-resp">Dimanche</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                <td></td>
                                                <td></td>
                                                <td className="table-resp"></td>
                                                <td></td>
                                                <td className="table-resp"></td>
                                                <td>8h30 à 10h00</td>
                                                <td className="table-resp"></td>
                                                </tr>

                                                <tr>
                                                <td>19h00 à 20h30</td>
                                                <td></td>
                                                <td className="table-resp"></td>
                                                <td></td>
                                                <td className="table-resp"></td>
                                                <td></td>
                                                <td className="table-resp"></td>
                                                </tr>
                                            </tbody>
                                            </Table>
                                            <p  className="pCenter"><i>*** Tous les horaires sont sujets à changement au courant de la saison.</i></p>
                                            
                                            <div className="pCenter">
                                                <p className="pCenter"> Lien<br/></p> <a className="link-history" href="https://www.fnq.qc.ca">Fédération de natation du Québec</a><br/>
                                                <a className="link-history" href="https://www.mymsc.ca">Maîtres-nageurs du Canada</a>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </Col>

                            <Col lg={12} md={12} sm={12} xs={12} className="nopadding">
                                <Footer />
                            </Col>
                        </Col>
                    </Row>
                </Container>
            </>
        )
    }
}

export default Natation
